import {useLazyQuery, useQuery} from "@apollo/client";
import {GetNewUser4Adventure} from "../../../../GraphQL/AdventureQueries";
import Button from "../../../../Atoms/Button";
import {
    PersonAddAlt1Sharp,
    PersonRemoveAlt1Sharp,
    SearchSharp,
    SignalCellularConnectedNoInternet0Bar
} from "@mui/icons-material";
import React, {useEffect} from "react";
import {PopUp} from "../../../../Atoms/PopUp";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {RootState} from "../../../../redux/store";
import {addUserToAdventure, removeUserFromAdventure} from "../../../../redux/slices/adventure/adventureSlice";
import {setIsAppLoading} from "../../../../redux/slices/content/contentSlice";
import {toast} from "react-toastify";
import {GetCharacter4User} from '../../../../GraphQL/CharacterQueries';
import {setCharacter} from '../../../../redux/slices/character/characterSlice';
import {Tabs} from '../AdventureMask';
import {user_to_adventure, userToAdventureInput} from '../../../../redux/slices/adventure/adventureType';
import * as _ from 'lodash'

export const AdventurePlayerTab = (props: {
    changeTab: (tab: Tabs) => void;
    setSelectedPlayer: (player: user_to_adventure | null) => void;
}) => {
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const dispatch = useAppDispatch();

    const {data: getNewUserData, loading: getNewUserLoading, error: getNewUserError} = useQuery(GetNewUser4Adventure, {
        variables: {
            adventureId: Number(adventure.adventureId)
        },
        fetchPolicy: 'network-only'
    });

    const [
        getCharacterSheet, {
            data: characterData,
            error: characterError,
            loading: characterLoading
        } ] = useLazyQuery(GetCharacter4User)

    const [ isAddUserVisible, setIsAddUserVisible ] = React.useState<boolean>(false);
    const [ isDeleteUserDialogVisible, setIsDeleteUserDialogVisible ] = React.useState<boolean>(false);
    const [ deleteUser, setDeleteUser ] = React.useState<user_to_adventure | null>(null);
    const [ newUserList, setNewUserList ] = React.useState<any[]>([]);

    useEffect(() => {
        if (characterLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Charakterbogen wird geladen...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ characterLoading ])

    useEffect(() => {
        if (characterError) {
            toast('Fehler beim Laden des Charakterbogens')
        }
    }, [ characterError ])

    useEffect(() => {
        if (getNewUserLoading) {
            dispatch(setIsAppLoading({loadingText: 'Nutzer werden geladen...', isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
        }
    }, [ getNewUserLoading ])

    useEffect(() => {
        if (getNewUserError) {
            toast('Fehler beim Laden der Nutzer')
        }
    }, [ getNewUserError ])

    useEffect(() => {
        if (getNewUserData) {
            setNewUserList(getNewUserData.getNewUser4Adventure);
        }
    }, [ getNewUserData ])

    const renderEmptyUserTable = () => {
        return (
            <div className='row mt-3'>
                <div className='col-12'>
                    Es wurden noch keine Nutzer eingeladen
                </div>
            </div>
        )
    }

    const handleRemoveUserFromAdventure = (user: any) => {
        dispatch(removeUserFromAdventure(user.userToAdventureId));
        let userList = _.cloneDeep(newUserList);
        userList.push(user.User);

        setNewUserList(userList);
    }

    const getCharacterName = (user: any) => {
        if (user.User.Character.length !== 0) {
            return user.User.Character.characterId === 0 ? 'Noch kein Charakter erstellt' : user.User.Character[0].characterName
        } else {
            return 'Noch kein Charakter erstellt'
        }
    }

    const selectPlayer = async (player: any) => {
        const characterSheet = await getCharacterSheet({
            variables: {
                userId: Number(player.User.userId),
                adventureId: Number(adventure.adventureId)
            },
            fetchPolicy: 'network-only'
        })
        if (characterSheet) {
            if (characterSheet.data) {
                dispatch(setCharacter({
                    characterName: characterSheet.data.getCharacters4User.characterName,
                    characterId: Number(characterSheet.data.getCharacters4User.characterId),
                    characterLevel: characterSheet.data.getCharacters4User.characterLevel,
                    characterExp: characterSheet.data.getCharacters4User.characterExp,
                    character_to_class: characterSheet.data.getCharacters4User.character_to_class,
                    Race: characterSheet.data.getCharacters4User.Race,
                    Subrace: characterSheet.data.getCharacters4User.Subrace,
                    CharacterSheet: characterSheet.data.getCharacters4User.CharacterSheet
                }))

                props.changeTab(Tabs.Spieleroverview);
                props.setSelectedPlayer(player);
            }
        }
    }

    const renderOneUser = (user: any) => {
        return (
            <div className='row mt-3'>
                <div className='col-1'>
                    {user.User.userId}
                </div>
                <div className='col-4'>
                    {user.User.userName}
                </div>
                <div className='col-4'>
                    {getCharacterName(user)}
                </div>
                <div className='col-3'>
                    <Button tooltip='Spieler entfernen'
                            onClick={() => {
                                setIsDeleteUserDialogVisible(true);
                                setDeleteUser(user)
                            }}><PersonRemoveAlt1Sharp/></Button>
                </div>
            </div>
        )
    }

    const renderUserTable = () => {
        const html = [];
        if (adventure.user_to_adventure.length !== 0) {
            for (const user of adventure.user_to_adventure) {
                html.push(renderOneUser(user))
            }
        } else {
            html.push(renderEmptyUserTable());
        }

        return html;
    }

    const handleAddNewUser = (user: userToAdventureInput) => {
        console.log(user);
        dispatch(addUserToAdventure({
            userName: user.userName,
            userId: user.userId,
            Character: [{
                characterName: '',
                characterId: 0,
                CharacterSheet: {
                    characterSheetId: 0,
                    initiative: 0,
                    armorClass: 0,
                    lifepoints: 0,
                    temporaryHitpoints: 0,
                    currentHitpoints: 0,
                    currentMana: 0,
                    spellSaveDc: 0,
                    spellAttackModifier: 0,
                    silver: 0,
                    gold: 0,
                    languages: "",
                    ability_to_characterSheet: [],
                    skill_to_characterSheet: [],
                    Spell: [],
                    Note: [],
                    Item: []
                }
            }]
        }));

        let userList = _.cloneDeep(newUserList);
        const deleteIndex = newUserList.findIndex(userInList => userInList.userId === user.userId);

        userList.splice(deleteIndex, 1);
        setNewUserList(userList);
    }

    const renderOneNewUser = (user: any) => {
        return (
            <div className='row mt-3 justify-content-center' key={user.userId}>
                <div className='col-1'>
                    {user.userId}
                </div>
                <div className='col-4'>
                    {user.userName}
                </div>
                <div className='col-3'>
                    <Button tooltip='Spieler Informationen' onClick={() => handleAddNewUser(user)}><PersonAddAlt1Sharp/></Button>
                </div>
            </div>
        )
    }

    const renderNewUserTable = () => {
        const html = [];
        if (getNewUserData) {
            if (getNewUserData.getNewUser4Adventure.length !== 0) {
                for (const user of newUserList) {
                    html.push(renderOneNewUser(user))
                }

            } else {
                html.push(renderEmptyUserTable())
            }
        }

        return html;
    }

    return (
        <div key={ adventure.adventureId }>
            {isDeleteUserDialogVisible && (
                <PopUp title='Nutzer hinzufügen' onClose={setIsDeleteUserDialogVisible}>
                    <div className='row text-center justify-content-evenly mt-5' style={{height: '40vh'}}>
                        <div className='col-8'>
                            <h2>Wollen Sie den Nutzer "{deleteUser?.User.userName}" wirklich entfernen?</h2>
                        </div>
                        <div className='col-6 text-end'>
                            <Button onClick={() => {
                                setDeleteUser(null);
                                setIsDeleteUserDialogVisible(false);
                            }}>Abbrechen</Button>
                        </div>
                        <div className='col-6 text-start'>
                            <Button onClick={() => {
                                handleRemoveUserFromAdventure(deleteUser);
                                setIsDeleteUserDialogVisible(false);
                            }}>Entfernen</Button>
                        </div>
                    </div>
                </PopUp>
            )}
            {isAddUserVisible && (
                <PopUp title='Nutzer hinzufügen' onClose={setIsAddUserVisible}>
                    <div className='row mt-5 justify-content-center'>
                        <div className='col-1'>
                            Nutzer-ID
                        </div>
                        <div className='col-4'>
                            Nutzername
                        </div>
                        <div className='col-3'>
                            Aktionen
                        </div>
                    </div>
                    {renderNewUserTable()}
                </PopUp>
            )}
            <div className='row justify-content-end'>
                <div className='col-2'>
                    <Button tooltip='Spieler hinzufügen'
                            onClick={() => setIsAddUserVisible(true)}><PersonAddAlt1Sharp/> Hinzufügen</Button>
                </div>
            </div>
            <div className='row mt-5'>
                <div className='col-1'>
                    Nutzer-ID
                </div>
                <div className='col-4'>
                    Nutzername
                </div>
                <div className='col-4'>
                    Charakter-Name
                </div>
                <div className='col-3'>
                    Aktionen
                </div>
            </div>
            <div className='adventure-user-table'>
                {renderUserTable()}
            </div>

        </div>
    )
}